import { createUseStyles } from 'react-jss'
import { Z_INDEX, TYPOGRAPHY, COLOR } from 'utils/constants'

export const useStyles = createUseStyles({
  wrapper: {
    width: '100%',
    height: '100%',
    position: 'relative',
    backgroundColor: COLOR.WHITE,
    WebkitBorderRadius: '50px',
    display: 'flex',
    flexDirection: 'column',
  },
  input: {
    padding: '20px 26px 16px',
    width: '100%',
    height: '100%',
    boxSizing: 'border-box',
    outline: 'none',
    ...TYPOGRAPHY.EXAMPLE,
    position: 'relative',
    fontSize: 21,
    zIndex: Z_INDEX.CONTENT,
    textAlign: 'left',
    letterSpacing: '0.05em',
    backgroundColor: COLOR.GREY_3,
    border: `1px solid ${COLOR.LIGHT_GREEN}`,
  },
  label: {
    paddingBottom: 5,
    display: 'inline-block',
    color: COLOR.DARK_GREEN,
    textTransform: 'uppercase',
  },
  hidden: {
    display: 'none',
  },
})
